import { defineComponent, ref, watch, nextTick } from '@vue/composition-api';
import { BfButton } from 'components/Butterfly';
import Modal from 'src/components/project/analysis/results/Modal.vue';
import DashboardSelection from './DashboardSelection.vue';
import { uniq } from 'lodash';
const ThemeNameModal = defineComponent({
    components: {
        BfButton,
        Modal,
        DashboardSelection,
    },
    props: {
        visible: { type: Boolean, required: true },
        dashboardList: { type: Array, required: true },
        canAddToDashboard: { type: Boolean, required: true },
        dashboardIds: { type: Array, required: true },
    },
    setup(props, { emit }) {
        const selectedDashboards = ref(props.dashboardIds ?? []);
        // Set form to current query values when modal is opened
        watch(() => props.visible, (newVal, oldVal) => {
            if (!oldVal && newVal) {
                nextTick(() => {
                    selectedDashboards.value = props.dashboardIds?.slice() ?? [];
                    selectedDashboards.value = uniq(selectedDashboards.value);
                });
            }
        });
        const update = () => {
            emit('update-theme', { dashboard_ids: selectedDashboards.value });
        };
        return {
            update,
            selectedDashboards,
        };
    },
});
export default ThemeNameModal;
